export const ourProducts = [
    {
      title: 'Sustainable Fashion Design Software',
      subtitle:
        'Elevate your fashion design process with Sustainable Fashion Design Software. Create eco-friendly and innovative designs while considering the environmental impact of materials and production methods.',
      img: 'url(/industries/textile/sustainable-fashion-design-software.jpg)',
      content:
        'Create eco-friendly and innovative designs while considering the environmental impact of materials and production methods with our Sustainable Fashion Design Software.',
      link: '/industries/textile/products/sustainable-fashion-design-software',
    },
    {
      title: 'Textile Production Process Optimization Software',
      subtitle:
        'Streamline your textile production processes with Optimization Software. Enhance efficiency, reduce waste, and improve resource utilization for a more sustainable and cost-effective manufacturing workflow.',
      img: 'url(/industries/textile/textile-production-process-optimization-software.jpg)',
      content:
        'Enhance efficiency, reduce waste, and improve resource utilization for a more sustainable and cost-effective manufacturing workflow with our Textile Production Process Optimization Software.',
      link: '/industries/textile/products/textile-production-process-optimization-software',
    },
    {
      title: 'Quality Control and Traceability Systems for Textiles',
      subtitle:
        'Ensure product quality and traceability throughout the textile supply chain with our Quality Control and Traceability Systems. Monitor production standards, track materials, and uphold quality assurance.',
      img: 'url(/industries/textile/quality-control-and-traceability-systems-for-textiles.jpg)',
      content:
        'Monitor production standards, track materials, and uphold quality assurance throughout the textile supply chain with our Quality Control and Traceability Systems for Textiles.',
      link: '/industries/textile/products/quality-control-and-traceability-systems-for-textiles',
    },
    {
      title: 'Apparel Design and Pattern Making Software',
      subtitle:
        'Transform your design process with Apparel Design and Pattern Making Software. Create intricate designs and precise patterns, speeding up the garment production cycle while ensuring accuracy.',
      img: 'url(/industries/textile/apparel-design-and-pattern-making-software.jpg)',
      content:
        'Create intricate designs and precise patterns, speeding up the garment production cycle while ensuring accuracy with our Apparel Design and Pattern Making Software.',
      link: '/industries/textile/products/apparel-design-and-pattern-making-software',
    },
    {
      title: 'Digital Textile Printing and Color Matching Tools',
      subtitle:
        'Achieve vibrant and accurate prints with Digital Textile Printing and Color Matching Tools. Enhance color consistency, reduce waste, and bring your textile designs to life with precision.',
      img: 'url(/industries/textile/digital-textile-printing-and-color-matching-tools.jpg)',
      content:
        'Enhance color consistency, reduce waste, and bring your textile designs to life with precision using our Digital Textile Printing and Color Matching Tools.',
      link: '/industries/textile/products/digital-textile-printing-and-color-matching-tools',
    },
    {
      title: 'Textile Recycling Management Systems',
      subtitle:
        'Embrace sustainability with Textile Recycling Management Systems. Implement efficient textile recycling processes, track recycled materials, and contribute to a circular economy in the textile industry.',
      img: 'url(/industries/textile/textile-recycling-management-systems.jpg)',
      content:
        'Implement efficient textile recycling processes, track recycled materials, and contribute to a circular economy in the textile industry with our Textile Recycling Management Systems.',
      link: '/industries/textile/products/textile-recycling-management-systems',
    },
    {
      title: 'Supply Chain Visibility and Collaboration Platforms for Textiles',
      subtitle:
        'Gain transparency across the textile supply chain with our Visibility and Collaboration Platforms. Facilitate communication, optimize processes, and ensure seamless collaboration among stakeholders.',
      img: 'url(/industries/textile/supply-chain-visibility-and-collaboration-platforms-for-textiles.jpg)',
      content:
        'Facilitate communication, optimize processes, and ensure seamless collaboration among stakeholders with our Supply Chain Visibility and Collaboration Platforms for Textiles.',
      link: '/industries/textile/products/supply-chain-visibility-and-collaboration-platforms-for-textiles',
    },
    {
      title: 'Environmental Impact Assessment Software for Textile Processes',
      subtitle:
        'Make informed decisions with Environmental Impact Assessment Software. Evaluate the environmental footprint of textile processes, identify areas for improvement, and embrace sustainable practices.',
      img: 'url(/industries/textile/environmental-impact-assessment-software-for-textile-processes.jpg)',
      content:
        'Evaluate the environmental footprint of textile processes, identify areas for improvement, and embrace sustainable practices with our Environmental Impact Assessment Software for Textile Processes.',
      link: '/industries/textile/products/environmental-impact-assessment-software-for-textile-processes',
    },
    {
      title: 'Inventory Management and Demand Planning for Textiles',
      subtitle:
        'Optimize inventory and meet customer demand with Inventory Management and Demand Planning solutions. Ensure efficient stock levels, minimize excess inventory, and enhance overall supply chain performance.',
      img: 'url(/industries/textile/inventory-management-and-demand-planning-for-textiles.jpg)',
      content:
        'Ensure efficient stock levels, minimize excess inventory, and enhance overall supply chain performance with our Inventory Management and Demand Planning for Textiles.',
      link: '/industries/textile/products/inventory-management-and-demand-planning-for-textiles',
    },
    {
      title: 'Fashion E-commerce and Virtual Fitting Room Applications',
      subtitle:
        'Elevate the online shopping experience with Fashion E-commerce and Virtual Fitting Room Applications. Allow customers to virtually try on garments, increasing engagement and reducing return rates.',
      img: 'url(/industries/textile/fashion-e-commerce-and-virtual-fitting-room-applications.avif)',
      content:
        'Allow customers to virtually try on garments, increasing engagement and reducing return rates with our Fashion E-commerce and Virtual Fitting Room Applications.',
      link: '/industries/textile/products/fashion-e-commerce-and-virtual-fitting-room-applications',
    },
    {
      title: 'Material Traceability and Transparency Software',
      subtitle:
        'Enhance transparency in your supply chain with Material Traceability Software. Provide customers with information about the origin and journey of materials, fostering trust and sustainability.',
      img: 'url(/industries/textile/material-traceability-and-transparency-software.avif)',
      content:
        'Provide customers with information about the origin and journey of materials, fostering trust and sustainability with our Material Traceability and Transparency Software.',
      link: '/industries/textile/products/material-traceability-and-transparency-software',
    },
    {
      title: 'Sustainable Supply Chain Management Solutions for Textiles',
      subtitle:
        'Embrace sustainability across the entire supply chain with our Sustainable Supply Chain Management Solutions. Ensure responsible sourcing, reduce environmental impact, and meet consumer demand for eco-friendly textiles.',
      img: 'url(/industries/textile/sustainable-supply-chain-management-solutions-for-textiles.jpg)',
      content:
        'Ensure responsible sourcing, reduce environmental impact, and meet consumer demand for eco-friendly textiles with our Sustainable Supply Chain Management Solutions for Textiles.',
      link: '/industries/textile/products/sustainable-supply-chain-management-solutions-for-textiles',
    },
    {
      title: 'CAD (Computer-Aided Design) Software for Textile Designers',
      subtitle:
        'Empower textile designers with CAD Software. Streamline design processes, create intricate patterns, and unleash creativity with tools tailored for the textile industry.',
      img: 'url(/industries/textile/cad-software-for-textile-designers.jpg)',
      content:
        'Streamline design processes, create intricate patterns, and unleash creativity with tools tailored for the textile industry with our CAD (Computer-Aided Design) Software for Textile Designers.',
      link: '/industries/textile/products/cad-software-for-textile-designers',
    },
    {
      title: 'Textile Chemical Management and Compliance Software',
      subtitle:
        'Ensure compliance and manage chemicals responsibly with Textile Chemical Management Software. Monitor and optimize chemical usage to meet regulatory standards and reduce environmental impact.',
      img: 'url(/industries/textile/textile-chemical-management-and-compliance-software.avif)',
      content:
        'Monitor and optimize chemical usage to meet regulatory standards and reduce environmental impact with our Textile Chemical Management and Compliance Software.',
      link: '/industries/textile/products/textile-chemical-management-and-compliance-software',
    },
    {
      title: 'Apparel Production Scheduling and Optimization Tools',
      subtitle:
        'Optimize your apparel production schedules with our Scheduling and Optimization Tools. Improve efficiency, reduce lead times, and meet customer demand with precision.',
      img: 'url(/industries/textile/apparel-production-scheduling-and-optimization-tools.jpg)',
      content:
        'Improve efficiency, reduce lead times, and meet customer demand with precision using our Apparel Production Scheduling and Optimization Tools.',
      link: '/industries/textile/products/apparel-production-scheduling-and-optimization-tools',
    },
    {
      title: 'RFID Technology for Textile Tracking and Authentication',
      subtitle:
        'Enhance textile tracking and authentication with RFID Technology. Improve inventory accuracy, combat counterfeiting, and ensure the integrity of your textile products.',
      img: 'url(/industries/textile/rfid-technology-for-textile-tracking-and-authentication.jpg)',
      content:
        'Improve inventory accuracy, combat counterfeiting, and ensure the integrity of your textile products with our RFID Technology for Textile Tracking and Authentication.',
      link: '/industries/textile/products/rfid-technology-for-textile-tracking-and-authentication',
    },
    {
      title: 'Textile Waste Reduction and Recycling Software',
      subtitle:
        'Take steps towards waste reduction and recycling with our Textile Waste Reduction Software. Implement efficient waste management strategies and contribute to a more sustainable textile industry.',
      img: 'url(/industries/textile/textile-waste-reduction-and-recycling-software.jpg)',
      content:
        'Implement efficient waste management strategies and contribute to a more sustainable textile industry with our Textile Waste Reduction and Recycling Software.',
      link: '/industries/textile/products/textile-waste-reduction-and-recycling-software',
    },
    {
      title: 'Apparel Manufacturing ERP (Enterprise Resource Planning) Systems',
      subtitle:
        'Streamline your apparel manufacturing processes with ERP Systems. Integrate production, inventory, and supply chain management for enhanced efficiency and responsiveness.',
      img: 'url(/industries/textile/apparel-manufacturing-erp-systems.jpg)',
      content:
        'Integrate production, inventory, and supply chain management for enhanced efficiency and responsiveness with our Apparel Manufacturing ERP (Enterprise Resource Planning) Systems.',
      link: '/industries/textile/products/apparel-manufacturing-erp-systems',
    },
    {
      title: 'Virtual Sampling and 3D Prototyping Software',
      subtitle:
        'Revolutionize product development with Virtual Sampling and 3D Prototyping Software. Reduce physical samples, accelerate design cycles, and bring products to market faster with realistic virtual representations.',
      img: 'url(/industries/textile/virtual-sampling-and-3d-prototyping-software.jpg)',
      content:
        'Reduce physical samples, accelerate design cycles, and bring products to market faster with realistic virtual representations using our Virtual Sampling and 3D Prototyping Software.',
      link: '/industries/textile/products/virtual-sampling-and-3d-prototyping-software',
    },
    {
      title: 'AI-Powered Trend Forecasting and Market Analysis Tools',
      subtitle:
        'Stay ahead of industry trends with AI-Powered Trend Forecasting and Market Analysis Tools. Analyze data, predict market trends, and make informed decisions to drive innovation in your textile designs.',
      img: 'url(/industries/textile/ai-powered-trend-forecasting-and-market-analysis-tools.avif)',
      content:
        'Analyze data, predict market trends, and make informed decisions to drive innovation in your textile designs with our AI-Powered Trend Forecasting and Market Analysis Tools.',
      link: '/industries/textile/products/ai-powered-trend-forecasting-and-market-analysis-tools', 
    },
  ]